<template>
<div>
    <div>
        <div class="mt-2 flex gap-2 text-red-500" v-if="job.error">
            <ElIconCircleCloseFilled :width="16"></ElIconCircleCloseFilled> Operation failed: {{ job.error }}
        </div>
        <div class="mt-2" v-else>
            <el-tag class="mr-1" type="warning" effect="dark" v-if="job.type == 'drm'">DRM</el-tag> 
            <span class="capitalize">{{ job.type }}</span> {{state.phase}} in progress
            <span v-if="state.phase == 'download' || state.phase == 'decrypt' || state.phase == 'merge' || state.phase == 'saving'">
                <template v-if="(state.progress.bytesTotal || state.progress.total) > 1000">
                    , {{ Math.round((state.progress.bytesDone || state.progress.done) / 1e6) }} / {{ Math.round((state.progress.bytesTotal || state.progress.total) / 1e6) }} MB
                </template>
                <template v-else-if="(state.progress.bytesDone || state.progress.done) > 0">
                    , {{ Math.round((state.progress.bytesDone || state.progress.done) / 1e6) }} MB
                </template>
                <template v-else-if="state.progress.total > 0">
                    , {{ state.progress.done }} / {{ state.progress.total }}
                </template>
                <span v-if="job.type == 'hls' && state.phase == 'download'" class="text-xs text-gray-500 ml-1">
                    ({{ state.progress.done }}/{{ state.progress.total }} segments)
                </span>
            </span>
        </div>
        <div class="mt-2 flex gap-2">
            <el-progress class="flex-grow" :text-inside="true" :stroke-width="18" :percentage="Math.round(state.progress.progress * 100)"></el-progress>
            
            <template v-if="job.type == 'hls' || job.type == 'dash' || job.type == 'download'">
                <el-button v-if="job.status == 'running'" style="zoom: 1.2; height: auto; padding: 0" class="flex-shrink" type="text" @click="pauseJob(job)">
                    <el-icon :size="20"><ElIconVideoPause /></el-icon>
                </el-button>
                <el-button v-if="job.status == 'paused' || job.status == 'error'" style="zoom: 1.2; height: auto; padding: 0" class="flex-shrink" type="text" @click="resumeJob(job)">
                    <div class="flex items-center gap-1">
                        <el-icon :size="20"><ElIconVideoPlay /></el-icon>
                        <span class="text-xs">Resume</span>
                    </div>
                </el-button>
            </template>

            <el-button style="zoom: 1.2; height: auto; padding: 0" class="flex-shrink" type="text" @click="cancelJob(job)">
                <el-icon :size="20"><ElIconCircleCloseFilled /></el-icon>
            </el-button>
        </div>
    </div>
</div>
</template>

<script>
import { CircleCloseFilled as ElIconCircleCloseFilled, VideoPause as ElIconVideoPause, VideoPlay as ElIconVideoPlay } from '@element-plus/icons-vue'

const {cancelJob, useExtension} = useHelpers()

export default {
    components: {
        ElIconCircleCloseFilled,
        ElIconVideoPause,
        ElIconVideoPlay
    },
    props: ['job'],
    methods: {
        cancelJob,
        async pauseJob (job) {
            if (job.type == 'hls') {
                await useExtension('hlsDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'dash') {
                await useExtension('dashDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'download') {
                await useExtension('downloadPool.pauseJob', [job.id], 'sandbox')
            }
        },
        async resumeJob (job) {
            if (job.type == 'hls') {
                await useExtension('hlsDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'dash') {
                await useExtension('dashDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'download') {
                await useExtension('downloadPool.resumeJob', [job.id], 'sandbox')
            }
        }
    },
    computed: {
        state () {
            return this.job.state
        }
    }
}
</script>